import React from 'react';
export function DescriptionSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 md:p-10 mb-12" data-id="element-1987">
      <div className="max-w-4xl mx-auto space-y-6 text-gray-700 text-lg leading-relaxed" data-id="element-1988">
        <p data-id="element-1989">
          CNC Sinker EDMs are offered in many configurations. Standard ball
          screw drives (CM323C, CM434C), Z-axis linear motor drives (D322CL,
          D433CL), full X Y & Z axis linear motor drives (A6040L), and large
          travel CNC sinkers (CM655C through CM3076C). All CNC models can be
          equipped with optional B axis and AB axis indexers, directly
          controlled by the CHMER CNC control.
        </p>
      </div>
    </div>;
}